<template>
  <div id="cuentas">
    <div v-if="loading" id="loading" class="loading_full">Loading&#8230;</div>
    <div class="card">
      <div class="card-body">
        <h4 class="fw-bolder mb-4">Cuentas</h4>
        <div class="text-end">
          <button
            data-bs-toggle="modal"
            data-bs-target="#nuevo"
            class="btn btn-info btn-rounded btn-sm"
          >
            <i class="fa fa-plus-circle"></i> Agregar
          </button>
        </div>
        <div>
          <div>
            <div v-if="cuentas.length != 0" class="table-responsive mt-3">
              <table class="table table-hover table-condensed my_table_1">
                <thead class="table-light">
                  <tr>
                    <th style="width: 20%">Cuenta</th>
                    <th style="width: 20%">Saldo</th>
                    <th style="width: 20%" class="text-center">Estado</th>
                    <th class="text-center" style="width: 10%">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(cuenta, index) in cuentas" v-bind:key="index">
                    <td>
                      <strong>{{ cuenta.cuenta }}</strong>
                    </td>
                    <td class="text-end">
                      <strong>{{ cuenta.saldo | currency }}</strong>
                    </td>
                    <td class="text-center">
                      <label v-if="cuenta.estado == 0" class="text-danger"
                        >Inactiva</label
                      >
                      <label v-if="cuenta.estado == 1" class="text-success"
                        >Activa</label
                      >
                    </td>
                    <td class="text-center">
                      <button
                        v-on:click="index_sel = index"
                        data-bs-toggle="modal"
                        data-bs-target="#editar"
                        class="btn btn-info btn-rounded btn-xs"
                        title="Detalles"
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                      <button
                        v-on:click="index_sel = index"
                        data-bs-toggle="modal"
                        data-bs-target="#eliminar"
                        class="btn btn-danger btn-rounded btn-xs"
                        title="Eliminar"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <div class="text-muted">
                <i class="fa-solid fa-circle-info"></i> No se han agregado
                cuentas bancarias.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="nuevo">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header text-success">
            <h5 class="modal-title fw-bolder">Crear cuenta</h5>
            <button
              id="close_nuevo"
              type="button"
              class="close"
              data-bs-dismiss="modal"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="form-group col-lg-12">
                <label>Cuenta Bancaria</label>
                <input
                  v-model="nueva.cuenta"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="form-group col-lg-12">
                <label>Saldo </label>
                <money
                  v-model="nueva.saldo"
                  class="form-control text-end"
                  v-bind="money"
                  required
                ></money>
              </div>
            </div>
            <div class="text-end">
              <button
                @click="setCuenta"
                class="btn btn-success btn-rounded btn-sm btn-icon-text"
              >
                <i class="fa fa-save"></i> Guardar
              </button>
              <button
                data-bs-dismiss="modal"
                class="btn btn-outline-dark btn-rounded btn-sm btn-icon-text ms-1"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="editar">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header text-success">
            <h5 class="modal-title fw-bolder">Editar cuenta</h5>
            <button
              id="close_editar"
              type="button"
              class="close"
              data-bs-dismiss="modal"
            >
              <span>&times;</span>
            </button>
          </div>
          <div v-if="index_sel != null" class="modal-body">
            <div class="row">
              <div class="form-group col-lg-12">
                <label>Cuenta</label>
                <input
                  v-model="cuentas[index_sel].cuenta"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="form-group col-lg-12">
                <label>Saldo</label>
                <money
                  v-model="cuentas[index_sel].saldo"
                  class="form-control text-end"
                  v-bind="money"
                  required
                ></money>
              </div>
              <div class="col-lg-12 form-group">
                <label>Estado</label>
                <select
                  v-model="cuentas[index_sel].estado"
                  class="form-control"
                >
                  <option value="1">Activo</option>
                  <option value="0">Inactivo</option>
                </select>
              </div>
            </div>
            <div class="text-end">
              <button
                @click="updateCuenta"
                class="btn btn-success btn-rounded btn-sm btn-icon-text"
              >
                <i class="fa fa-save"></i> Guardar
              </button>
              <button
                data-bs-dismiss="modal"
                class="btn btn-outline-dark btn-rounded btn-sm btn-icon-text ms-1"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="eliminar">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header text-danger">
            <h5 class="modal-title fw-bolder">Eliminar cuenta</h5>
            <button
              id="close_eliminar"
              type="button"
              class="close"
              data-bs-dismiss="modal"
            >
              <span>&times;</span>
            </button>
          </div>
          <div v-if="index_sel != null" class="modal-body">
            <div class="row">
              <div class="col-lg-12 text-danger mb-3">
                <label
                  >¿Desea eliminar la cuenta
                  {{ cuentas[index_sel].cuenta }}?</label
                >
              </div>
            </div>
            <div class="text-end">
              <button
                @click="deleteCuenta"
                class="btn btn-danger btn-rounded btn-sm btn-icon-text"
              >
                <i class="fa fa-trash"></i> Sí, eliminar
              </button>
              <button
                data-bs-dismiss="modal"
                class="btn btn-outline-dark btn-rounded btn-sm btn-icon-text ms-1"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";

import { Money } from "v-money";
export default {
  name: "Cuentas",
  metaInfo: {
    title: "Cuentas Bancarias - Backoffice",
  },
  data() {
    return {
      loading: true,
      page: 1,
      index_sel: null,
      cuentas: [],
      nueva: {
        cuenta: null,
        saldo: 0,
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "$ ",
        suffix: "",
        precision: 0,
        masked: false,
      },
    };
  },
  props: {
    session: Object,
  },
  components: { Money },
  created: function () {
    this.get_cuentas();
  },
  methods: {
    get_cuentas: function () {
      const vm = this;
      vm.loading = true;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": vm.$api_key,
        Token: vm.session.usuario.token_session,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(vm.$base_url + "admin/cuentas", config, {
          headers: headers,
        })
        .then((response) => {
          if (response.data.status) {
            vm.cuentas = response.data.data.cuentas;
          } else {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Cuentas bancarias",
              text: response.data.message,
            });
          }
          vm.loading = false;
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Cuentas bancarias",
            text: error,
          });
          vm.loading = false;
        });
    },
    setCuenta: function () {
      const vm = this;
      vm.loading = true;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        Token: vm.session.usuario.token_session,
      };
      let params = {
        cuenta: this.nueva,
      };
      axios
        .post(this.$base_url + "admin/setCuenta", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Error!",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              group: "foo",
              type: "success",
              title: "Excelente!",
              text: response.data.message,
            });
            vm.nueva = {
              cuenta: null,
              saldo: 0,
            };

            vm.get_cuentas();
          }
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Error",
            text: error,
          });
        })
        .finally();
    },
    updateCuenta: function () {
      const vm = this;
      vm.loading = true;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        Token: vm.session.usuario.token_session,
      };
      let params = {
        cuenta: this.cuentas[this.index_sel],
      };
      axios
        .post(this.$base_url + "admin/updateCuenta", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Error!",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              group: "foo",
              type: "success",
              title: "Excelente!",
              text: response.data.message,
            });
            vm.get_cuentas();
          }
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Error",
            text: error,
          });
        })
        .finally();
    },
    deleteCuenta: function () {
      const vm = this;
      vm.loading = true;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        Token: vm.session.usuario.token_session,
      };
      let params = {
        idCuenta: this.cuentas[this.index_sel].id_cuenta,
      };
      axios
        .post(this.$base_url + "admin/deleteCuenta", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Error!",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              group: "foo",
              type: "success",
              title: "Excelente!",
              text: response.data.message,
            });
          }
          vm.index_sel = null;
          document.getElementById("close_eliminar").click();
          vm.get_cuentas();
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Error",
            text: error,
          });
          vm.loading = false;
        })
        .finally();
    },
  },
};
</script>
